import { render, staticRenderFns } from "./business-regulation.vue?vue&type=template&id=b1b4c666"
import script from "./business-regulation.vue?vue&type=script&lang=js"
export * from "./business-regulation.vue?vue&type=script&lang=js"
import style0 from "./business-regulation.vue?vue&type=style&index=0&id=b1b4c666&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports